import { c as _c } from "react/compiler-runtime";
import AboutHero from "@/components/about/AboutHero";
import AboutStory from "@/components/about/AboutStory";
import AboutValues from "@/components/about/AboutValues";
import FAQ from "@/components/shared/FAQ";
import ResearchCTA from "@/components/home/ResearchCTA";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
export default function About() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("about");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
      name: "Home",
      path: "/"
    }, {
      name: "About",
      path: "/about"
    }])} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<main className="min-h-screen bg-[#F4EFE6]"><AboutHero /><AboutStory /><AboutValues /><FAQ /><ResearchCTA /></main></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}